import { useRef, useEffect, useState } from 'react';
import Inputbox from './Inputbox';
import { countryData } from '../../utils/constants';
import DropDownIcon from '../../assets/images/dropdown.svg';

export default function IdentificationInputbox({
  disabled = false,
  citizenData,
  onChange,
}) {
  const countryCodeRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [nationality, setNationality] = useState({
    flag: '',
    areaCode: '',
    country: '',
    isoCode3: '',
  });
  const [number, setNumber] = useState('');
  const onChangeCitizenNumber = (value) => {
    if (value && !/^[0-9]+$/.test(value)) return;
    onChange('number', value);
  };

  useEffect(() => {
    setNationality(citizenData.nationality);
    setNumber(citizenData.number);
  }, [citizenData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryCodeRef.current &&
        !countryCodeRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full flex items-center space-x-2">
      <div className="space-y-1 inline min-w-25 w-25">
        <div className="font-[poppins] text-xs text-[#414651] font-normal leading-[20px] tracking-[0%]">
          País emisor
        </div>

        <div className="relative" ref={countryCodeRef}>
          <button
            onClick={() => {
              if (!disabled) setOpen(!open);
            }}
            className="w-full px-3 py-2 flex items-center cursor-pointer justify-between focus:outline-none focus:border-[#414651] border border-gray-300 rounded-lg bg-white"
          >
            <div className="flex items-center space-x-1">
              {nationality.flag ? (
                <img src={nationality.flag} alt="Flag" className="w-5 h-5" />
              ) : (
                <div className="w-5 h-5 rounded-full overflow-hidden">
                  <div className="w-full h-2.5 bg-[#D5D7DA]"></div>
                  <div className="w-full h-[5px] bg-[#E9EAEB]"></div>
                  <div className="w-full h-[5px] bg-[#F5F5F5]"></div>
                </div>
              )}
              <span
                className={`font-[poppins] text-sm ${
                  nationality.isoCode3 ? 'text-[#414651]' : 'text-[#A4A7AE]'
                }`}
              >
                {nationality.isoCode3 ? nationality.isoCode3 : 'AAA'}
              </span>
            </div>
            <img src={DropDownIcon} alt="Drop Down Icon" className="w-5 h-5" />
          </button>

          {open && (
            <ul
              style={{ scrollbarWidth: 'thin' }}
              className="absolute z-10 mt-1 w-full max-h-78 h-78 overflow-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent bg-white border border-gray-300 rounded-lg shadow"
            >
              {countryData.map((item, idx) => (
                <li
                  key={idx}
                  onClick={() => {
                    onChange('nationality', item);
                    setOpen(false);
                  }}
                  className="flex items-center px-4 py-2 space-x-2 hover:bg-gray-100 cursor-pointer"
                >
                  <img src={item.flag} alt="Flag" className="w-5 h-5" />
                  <span className="text-sm text-[#414651]">
                    {item.isoCode3}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <Inputbox
        disabled={disabled}
        inputClass="bg-white"
        title="Número de identificación"
        titleClass="text-[#424242]"
        placeholder="1122334455"
        value={number}
        onChange={onChangeCitizenNumber}
      />
    </div>
  );
}
